import _flow from 'lodash/flow'
import _orderBy from 'lodash/orderBy'
import {
  getComplianceLevels,
  getILUEvaluationReasons,
  saveILUEvaluationReasons,
} from 'frontend/communications/apiClient'

const moduleState = {
  positiveReasons: [],
  negativeReasons: [],
  complianceLevels: null,
}

const getters = {
  getComplianceLevels (state) {
    return state.complianceLevels ? _orderBy(state.complianceLevels, 'order') : null
  },
  getEvaluationReasonById: (state) => (id) => {
    const reasons = [...state.positiveReasons, ...state.negativeReasons]
    return reasons.find(reason => reason.id === id)
  },
  getEvaluationReasonByTitle: (state) => (title) => {
    const reasons = [...state.positiveReasons, ...state.negativeReasons]
    return reasons.find(reason => reason.title === title)
  },
  getPositiveILUEvaluationReasons (state) {
    return state.positiveReasons
  },
  getNegativeILUEvaluationReasons (state) {
    return state.negativeReasons
  },
}

const mutations = {
  setComplianceLevels (state, value) {
    state.complianceLevels = value
  },
  updateILUEvaluationReasons (state, reasons) {
    state.positiveReasons = _flow([
      () => reasons.filter(reason => reason.reason_type === 0),
      items => _orderBy(items, ['order'], ['asc']),
    ])()
    state.negativeReasons = _flow([
      () => reasons.filter(reason => reason.reason_type === 1),
      items => _orderBy(items, ['order'], ['asc']),
    ])()
  },
}

const actions = {
  async fetchILUEvaluationReasons ({ commit }) {
    const remoteReasons = await getILUEvaluationReasons()
    commit('updateILUEvaluationReasons', remoteReasons)
    return remoteReasons
  },
  updateILUEvaluationReasons ({ commit }, reasons) {
    return new Promise(resolve => {
      const reasonsToCreate = reasons.filter(reason => !reason.id)
      const reasonsToUpdate = reasons.filter(reason => reason.id)
      Promise.all([
        saveILUEvaluationReasons(reasonsToCreate, true),
        saveILUEvaluationReasons(reasonsToUpdate),
      ]).then(([createdReasons, updatedReasons]) => {
        const remoteReasons = _orderBy([...createdReasons, ...updatedReasons], ['order'])
        commit('updateILUEvaluationReasons', remoteReasons)
        resolve(remoteReasons)
      })
    })
  },
  async fetchComplianceLevels ({ commit }, reasons) {
    const remoteLevels = await getComplianceLevels(reasons)
    commit('setComplianceLevels', remoteLevels)
    return remoteLevels
  },
}

export default {
  state: moduleState,
  getters,
  mutations,
  actions,
}
